import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Config from '../../../../axios/Config';
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from '../../../../utils/Notify';
import {
  ADD_FID_CARD,
  LOGIN_FID_SCAN,
  SCAN,
} from '../../../../constants/routes';
import FidCardScreen from './FidCardScreen';
import { addFidCard } from '../../../../actions/fidelityActions';

const LoginAddFidCardScreen = () => {
  const navigate = useNavigate();
  const axiosInstance = Config();
  const location = useLocation();
  const image = location?.state?.image;
  const user = useSelector((state) => state.user);
  const { cartItems } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const [recaptchaResultToken, setRecaptchaResultToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const onAddFidCardSuccess = (fidCardNum, data) => {
    if (data?.fidCard[0]?.fidelityInfo?.statutIdentification === 'OK') {
      navigate(SCAN, { state: { fidCardNum: fidCardNum } });
      notifySuccess('Carte ajoutée !');
    } else {
      notifyError("Erreur lors de l'ajout de la carte");
    }
  };

  const login = (fidCardNum) => {
    if (!fidCardNum) {
      notifyWarning('Il faut saisir un numéro de carte de fidélité.');
      return;
    }
    setIsLoading(true);
    addFidCard(
      axiosInstance,
      user,
      cartItems,
      fidCardNum,
      store?.id,
      recaptchaResultToken,
      (data) => onAddFidCardSuccess(fidCardNum, data),
      () => setIsLoading(false),
    );
  };

  return (
    <FidCardScreen
      onConfirm={login}
      onBack={() => navigate(-1)}
      goToScan={() => navigate(LOGIN_FID_SCAN, { state: { image: image, prevPage: ADD_FID_CARD } })}
      companyLogo={image}
      setRecaptchaResultToken={setRecaptchaResultToken}
      isLoading={isLoading}
      companyName={store?.name}
    />
  );
};

export default LoginAddFidCardScreen;
